import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Box, Container, Grid, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import InternalSlidePage from '../components/resuableComponents/InternalSlidePage';

const HolidaysDetailPage = () => {
	const location = useLocation();
	console.log('location', location);
	return (
		<div>
			<Navbar />
			<Container style={{ marginTop: 10, marginBottom: 50 }}>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						<Box
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								marginTop: 20,
								padding: 30,
								borderRadius: 5,
							}}>
							{/* <h1 style={{ fontSize: 26 }}>{location.state.title}</h1> */}

							<Box
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}>
								<Box>
									<span style={{ fontSize: 18 }}>{location.state.title}</span>
									<br></br>
									<span
										style={{
											fontSize: 14,
											color: 'rgba(0,0,0,.38)',
										}}>
										Travel{' '}
										<span
											style={{
												color: 'black',
												fontWeight: 'bold',
											}}>
											{location.state.day}{' '}
										</span>
										days{' '}
										<span
											style={{
												color: 'black',
												fontWeight: 'bold',
											}}>
											{location.state.night}
										</span>{' '}
										nights
										{/* {location.state.departure_city} */}
									</span>
									<br></br>
									<span style={{ fontSize: 20 }}>
										{' '}
										{/* {timeConvertbus(item.departureTime)} */}
									</span>
								</Box>
								<Box
									mt={1}
									style={{
										display: 'flex',
										// justifyContent: 'space-between',
										// alignItems: 'center',
									}}>
									<img
										src='https://cdn-icons-png.flaticon.com/512/3125/3125713.png'
										style={{ height: 30, width: 30 }}
									/>
									<img
										src='https://png.pngtree.com/png-vector/20190623/ourmid/pngtree-hotel-icon-png-image_1511479.jpg'
										style={{
											height: 30,
											width: 30,
											marginLeft: 5,
										}}
									/>
									<img
										src='https://cdn-icons-png.flaticon.com/512/5159/5159840.png'
										style={{
											height: 30,
											width: 30,
											marginLeft: 5,
										}}
									/>
									<img
										src='https://cdn-icons-png.flaticon.com/512/5030/5030991.png'
										style={{
											height: 30,
											width: 30,
											marginLeft: 5,
										}}
									/>
								</Box>
							</Box>

							{/* <img
								src={location.state.image}
								style={{ height: '100%', borderRadius: 5, marginTop: 20 }}
							/> */}
							<br></br>
							<InternalSlidePage images={location.state.subCatimage} />
						</Box>
					</Grid>
					<Grid item xs={4}>
						<Box
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								marginTop: 20,
								padding: 30,
								display: 'flex',
								justifyContent: 'space-between',
								borderRadius: 5,
							}}>
							<Box>
								<span>SUPER DEAL PRICE</span>
								<br></br>
								<span style={{ fontSize: 13, color: 'grey' }}>STARTS FROM</span>
								<br></br>
								<span style={{ fontSize: 24, fontWeight: 'bold' }}>
									₹37,000
								</span>
							</Box>
							<Button
								style={{
									background: 'yellow',
									height: '36px',
									color: 'black',
									border: '1px solid yellow',
								}}>
								Quick Quote
							</Button>
						</Box>
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</div>
	);
};

export default HolidaysDetailPage;
